<template>
  <div>
    <Title
      :pages="[
        { icon: 'rectangle-list', page: page_title.toUpperCase() },
        { icon: 'circle', page: getName() },
      ]"
    ></Title>

    <v-container fluid>
      <div class="mb-5 d-flex align-center flex-wrap" v-if="update_access">
        <v-btn color="primary" class="mr-2 mb-1" :disabled="selected.length === 0" @click="dialog_bulk_update = true">
          Aumento masivo de precios
        </v-btn>
        <v-btn color="primary" class="mr-3 mb-1" :disabled="selected.length === 0" @click="dialog_bulk_discount = true">
          Descuento masivo
        </v-btn>
        <span class="grey--text text--darken-1 mb-1">
          {{ selected.length > 0 ? selected.length + " producto(s) seleccionado(s)" : "Seleccione productos para aplicar cambios masivos" }}
        </span>
      </div>

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ getName() }}</span>
          <v-spacer></v-spacer>
          <v-select
            v-model="category_filter"
            :items="categories_options"
            item-text="name"
            item-value="id"
            label="Filtrar por rubro"
            clearable
            hide-details
            dense
            outlined
            class="mr-4"
            style="max-width: 260px"
          ></v-select>
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            hide-details
            dense
            outlined
            style="max-width: 220px"
          ></v-text-field>
        </v-card-title>

        <v-data-table
          :headers="headers"
          :items="filtered_list"
          :search="search"
          :loading="loading"
          v-model="selected"
          show-select
          item-key="product_presentation_id"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
        >
          <template v-slot:[`item.price`]="{ item }">
            <span class="d-block text-right">{{ formatUtils.formatPrice(item.price) }}</span>
          </template>
          <template v-slot:[`item.discount_per`]="{ item }">
            <span class="d-block text-right">{{ item.discount_per != null ? item.discount_per + "%" : "-" }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="text-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(item)"> edit </v-icon>
                </template>
                <span>Editar</span>
              </v-tooltip>
            </div>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <ModalBulkUpdate
        :show="dialog_bulk_update"
        @close="dialog_bulk_update = false"
        @refresh="loadList(service)"
        :seleted="lista_de_precios"
        :product_presentation_ids="selected_presentation_ids"
      />

      <ModalBulkDiscount
        :show="dialog_bulk_discount"
        @close="dialog_bulk_discount = false"
        @refresh="loadList(service)"
        :seleted="lista_de_precios"
        :product_presentation_ids="selected_presentation_ids"
      />

      <ModalProductPrice
        v-if="update_access"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />
    </v-container>
  </div>
</template>

<script>
import { priceListService } from "@/libs/ws/priceListService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import ModalBulkUpdate from "./ModalBulkUpdate.vue";
import ModalBulkDiscount from "./ModalBulkDiscount.vue";
import Title from "@/components/Title.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import ModalProductPrice from "./ModalProductPrice.vue";

export default {
  components: { Title, ModalBulkUpdate, ModalBulkDiscount, ModalProductPrice },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      formatUtils: formatUtils,
      service: priceListService,
      page_title: "Listas de precio",
      modal_title: "Lista de precio",
      lista_de_precios: [],
      category_filter: null,
      mainItem: {
        id: "",
        name: "",
        product_presentation_id: "",
        price_list_id: "",
        price: 0,
        enabled: true,
      },
      defaultItem: null,
      headers: [
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "label",
        },
        {
          text: "Rubro",
          align: "left",
          sortable: true,
          value: "category.name",
        },
        {
          text: "Precio unitario s/IVA",
          align: "right",
          sortable: true,
          value: "price",
        },
        {
          text: "% Bonificacion",
          align: "right",
          sortable: true,
          value: "discount_per",
        },
        { text: "Accion", value: "actions", align: "center", sortable: false },
      ],
      list: [],
      dialog_bulk_update: false,
      dialog_bulk_discount: false,
      price_list_name: "",
    };
  },
  computed: {
    // Rubros presentes en la lista, para el filtro rapido.
    categories_options() {
      const map = {};
      this.list.forEach((row) => {
        if (row.category) map[row.category.id] = row.category.name;
      });
      return Object.keys(map).map((id) => ({ id: Number(id), name: map[id] }));
    },
    // Filas visibles segun el filtro por rubro (la busqueda por texto la maneja la tabla).
    filtered_list() {
      if (this.category_filter == null) return this.list;
      return this.list.filter((row) => row.category && row.category.id === this.category_filter);
    },
    // Ids de presentacion seleccionados, que definen el alcance de los cambios masivos.
    selected_presentation_ids() {
      return this.selected.map((row) => row.product_presentation_id);
    },
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
  },
  methods: {
    getName() {
      return this.price_list_name;
    },
    setVariables() {
      if (this.list.length > 0) {
        this.price_list_name = this.list[0].price_list_name;
      }
      var item_arr = [
        {
          id: this.$route.params.price_list_id,
          name: this.price_list_name,
        },
      ];

      this.lista_de_precios = Object.assign([], this.lista_de_precios, item_arr);
    },
    loadList(service, param = null) {
      this.loading = true;

      if (param == null) {
        param = {
          prices_list_id: this.$route.params.price_list_id,
        };
      }

      this.open_filter = false;
      service
        .getPriceList(param)
        .then((response) => {
          this.list = response.result;

          this.setVariables();
          this.loading = false;

          if (typeof this.selected !== "undefined") {
            this.selected = [];
          }
        })
        .catch((e) => {
          console.log("service.filter error");
          console.log(e);
          this.loading = false;
        });
    },
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
